var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundpatternlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 336,
    viewBox: "0 0 336 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1776_32184",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    fill: "url(#paint0_radial_1776_32184)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1776_32184)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 71.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 95.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 119.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 143.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 167.5,
    stroke: "#EAECF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1776_32184",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundpatternlight);
export default __webpack_public_path__ + "static/media/Background pattern light.5e8d4ae6268b788b4bc6494ce3806e3b.svg";
export { ForwardRef as ReactComponent };